import { useState } from 'react';
import {
  Box,
  TextField,
  Button,
  Typography,
  InputAdornment,
  IconButton,
} from '@mui/material';
import { toast } from 'react-toastify';
import auth from '@/services/AuthService';
import ToastMessage from '@/components/toasts/ToastMessage';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import MfaOptions from './MfaOptions';
import { useTheme } from '@emotion/react';

export default function SetPasswordAnd2FA({ token, onSuccess, onFailure }) {
  const theme = useTheme();
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordSet, setPasswordSet] = useState(false);
  const [showPasswords, setShowPasswords] = useState({
    showPassword: false,
    showConfirmPassword: false,
  });

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleConfirmPasswordChange = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handle2FASetupSuccess = () => {
    onSuccess();
  };

  const handle2FASetupFailure = (message) => {
    onFailure(message);
    setPasswordSet(true);
  };

  const handlePasswordSubmit = async () => {
    if (password !== confirmPassword) {
      toast.error(<ToastMessage title="Passwörter stimmen nicht überein" />);
      return;
    }
    try {
      await auth.post('/setInitialPassword', {
        token,
        newPassword: password,
        confirmPassword: confirmPassword,
      });
      setPasswordSet(true);
      toast.success(<ToastMessage title="Passwort erfolgreich gesetzt" />);
    } catch (e) {
      console.error(e?.response?.data?.message);
      handle2FASetupFailure(e?.response?.data?.message);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '0 auto',
        padding: '20px',
      }}
    >
      {!passwordSet ? (
        <Box
          sx={{
            maxWidth: '500px',
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
            Bitte setzen Sie ihr Passwort und aktivieren Sie die
            Zwei-Faktor-Authentifizierung.
          </Typography>
          <Typography
            sx={{
              mt: '22px',
              fontSize: '16px',
              [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
              },
            }}
          >
            Bitte wählen Sie ein sicheres Passwort.
          </Typography>
          <TextField
            fullWidth
            label="Passwort"
            value={password}
            type={showPasswords.showPassword ? 'text' : 'password'}
            onChange={handlePasswordChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handlePasswordSubmit();
              }
            }}
            sx={{ mt: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setShowPasswords((prev) => ({
                        ...prev,
                        showPassword: !prev.showPassword,
                      }))
                    }
                    edge="end"
                  >
                    {showPasswords.showPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            fullWidth
            label="Passwort bestätigen"
            type={showPasswords.showConfirmPassword ? 'text' : 'password'}
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handlePasswordSubmit();
              }
            }}
            sx={{ mt: 2 }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() =>
                      setShowPasswords((prev) => ({
                        ...prev,
                        showConfirmPassword: !prev.showConfirmPassword,
                      }))
                    }
                    edge="end"
                  >
                    {showPasswords.showConfirmPassword ? (
                      <VisibilityIcon />
                    ) : (
                      <VisibilityOffIcon />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handlePasswordSubmit}
            sx={{ mt: 2 }}
          >
            Passwort setzen
          </Button>
        </Box>
      ) : (
        <MfaOptions
          onSetupSuccess={handle2FASetupSuccess}
          onSetupFailure={handle2FASetupFailure}
        />
      )}
    </Box>
  );
}
